import { Button } from "@herskin/ui";
import type { RunRecoveryResponse } from "@herskin/contracts";

export type RunRecoveryAction = "checking" | "completed" | "failed" | null;

interface RunRecoveryCardProps {
  runId: string | null;
  result: RunRecoveryResponse | null;
  busyAction: RunRecoveryAction;
  onCheck: () => void;
  onResolve: (outcome: "completed" | "failed") => void;
}

export function RunRecoveryCard({
  runId,
  result,
  busyAction,
  onCheck,
  onResolve,
}: RunRecoveryCardProps) {
  const needsConfirmation = result?.state === "confirmation_required";
  return (
    <section className="run-recovery" role="alert" aria-labelledby="run-recovery-title">
      <div className="run-recovery-copy">
        <strong id="run-recovery-title">上一轮发送结果待确认</strong>
        <p>
          {needsConfirmation
            ? "Hermes 没有足够证据判断本轮是否执行。请先查看会话中的实际结果，再人工确认。"
            : "为避免重复发送文字或附件，HerSkin 已暂停本会话的新消息。先检查 Hermes 的真实状态，不会自动重发。"}
        </p>
      </div>
      <div className="run-recovery-actions">
        <Button
          type="button"
          variant={needsConfirmation ? "secondary" : "primary"}
          size="sm"
          isLoading={busyAction === "checking"}
          loadingLabel="正在检查"
          disabled={busyAction !== null}
          onClick={onCheck}
        >
          {runId ? "检查真实状态" : "重新载入运行信息"}
        </Button>
        {needsConfirmation ? (
          <>
            <Button
              type="button"
              variant="secondary"
              size="sm"
              isLoading={busyAction === "completed"}
              loadingLabel="正在确认"
              disabled={busyAction !== null}
              onClick={() => onResolve("completed")}
            >
              确认已完成
            </Button>
            <Button
              type="button"
              variant="danger"
              size="sm"
              isLoading={busyAction === "failed"}
              loadingLabel="正在确认"
              disabled={busyAction !== null}
              onClick={() => onResolve("failed")}
            >
              确认未执行
            </Button>
          </>
        ) : null}
      </div>
      {needsConfirmation ? <small>人工确认只解除本轮阻塞，不会重放原消息或原附件。</small> : null}
    </section>
  );
}
